var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 412,
    height: 519,
    viewBox: "0 0 412 519",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_689",
    "data-name": "Rectangle 689",
    width: 412,
    height: 519,
    transform: "translate(0 209)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_9",
    "data-name": "Mask Group 9",
    transform: "translate(0 -209)",
    opacity: 0.15,
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(3620.018 7676.916) rotate(-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M-2028.356-7992.308s280.749,42.209,453.848,30.314,279.191-58.478,397.543-54.953,0,81.542,0,81.542-128.211-30.125-409.757,22.029-530.39,24.95-530.39,24.95Z",
    transform: "translate(131.687 11)",
    fill: "#0e429a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M-2020.668-7927.194s97.718,24.735,337.959,14.595,183.957-76.549,517.122-24.229-100.622,45.373-100.622,45.373-84.385-22.457-330.337,29.427-520.49-23.5-520.49-23.5Z",
    transform: "translate(131.687 11)",
    fill: "#0060af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M-1936.053-7996.542s188.446,46.443,361.545,34.548,279.191-58.478,397.543-54.953,0,81.542,0,81.542-128.211-30.125-409.757,22.029-417.171-5.565-417.171-5.565Z",
    transform: "translate(-28 144)",
    fill: "#0592e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M-1936.053-7996.542s188.446,46.443,361.545,34.548,302.91-71.64,485.4-71.452,26.143,98.385,26.143,98.385-230-7.888-511.545,44.267-429.385-28.147-429.385-28.147Z",
    transform: "translate(-161 206.79)",
    fill: "#44d3f8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.6ea6654c6f83069c9cf2c101a19eb9d6.svg";
export { ForwardRef as ReactComponent };